<template>
  <ReferenceComponentParentList
    :searchList="list"
    :componentType="componentType"
    :selectedIndex="selectedIndex"
    :isLast="isLast"
    @onClick="onProjectSelected"
    @onScroll="onScroll"
  >
    <template #header>
      <BaseSubHeading
        weight="600"
        size="medium"
        color="monochrome-06"
      >
        Projects
      </BaseSubHeading>
    </template>

    <template #item="{ option }">
      <BaseSubHeading
        weight="400"
        size="medium"
        color="monochrome-06"
        className="reference-list__item-in"
      >
        {{ option.name }}
      </BaseSubHeading>
    </template>
  </ReferenceComponentParentList>
</template>

<script lang="ts">
import { mixins, Options } from "vue-class-component"
import { Action } from "s-vuex-class"

import ReferenceComponentListCommon from "@/components/Reference/helpers/ReferenceComponentListCommon"
import ReferenceComponentParentList from "@/components/Reference/helpers/ReferenceComponentParentList.vue"

import { SearchProject, SearchProjectResult, ServerResponse } from "@/models"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Actions } from "@/store"
import { parsingServerResponseContent } from "@/utils"

const components = {
  ReferenceComponentParentList
}

@Options({
  name: "ProjectList",
  components
})
export default class extends mixins(ReferenceComponentListCommon) {
  @Action(Actions.SEARCH_PROJECT_BY_FILTER) findProjects: (
    filter: SearchProject
  ) => Promise<ServerResponse<SearchProjectResult>>

  componentType = ReferenceType.PROJECT
  waitTitle = "reference.search.project"
  result: SearchProjectResult[] = []
  isLast = true

  get list() {
    return this.result?.length > 0 ? this.result : []
  }

  async mounted() {
    this.filter = new SearchProject()
    this.searchAction = this.onSearchProjects
  }

  queryUpdated(q) {
    this.filter.page = 1
    this.filter.q = q.substring(1) ?? ""
    this.search()
  }

  onEnterHandler() {
    this.onProjectSelected(this.result[this.selectedIndex])
  }

  onProjectSelected(payload: SearchProjectResult) {
    this.selectItem({
      item: payload,
      payload: {}
    })
  }

  async onSearchProjects() {
    const serverResponse = await this.findProjects(this.filter)
    if (!serverResponse) return
    this.result = parsingServerResponseContent({
      originalContent: this.result,
      serverResponseContent: serverResponse.content,
      numberOfPage: serverResponse.pageable.pageNumber
    })
    this.isLast = serverResponse.last
  }
}
</script>
